import React from 'react';
import {useSelector} from 'react-redux';
import CartElementCheckout from "./CartElementCheckout";
import {getDayNr} from "../../utils/cartUtils";
import {formatCartElementDate} from "../../utils/dateTimeUtils";
import { Trans, useLingui } from '@lingui/react/macro';
import capitalize from 'lodash/capitalize';
import { getExcursionText } from '../../utils/themeUtils';


function CartExcursionEntryCheckout(props) {
    const excursion = props.excursion;
    const cruiseStartDate = useSelector(state => state.cruises.cruiseStartDate);
    const {t} = useLingui();

    const excursionText = getExcursionText();
    const pricePreText = 
        excursion.status === "Waitlisted"
            ? capitalize(t({ id: "excursion_cost_if_confirmed", message: `${excursionText} cost if confirmed`}))
            : capitalize(t({id: "excursion_cost", message: `${excursionText} Cost`}));
    return (
        <CartElementCheckout
            name={excursion.excursionName}
            imageReference={excursion.excursionId}
            imageCategory="cruiseExcursion"
            linkTo={ t({id: "/excursion"}) + `/${excursion.itineraryId}/${excursion.excursionId}`}
            pricePreText={pricePreText}
            price={excursion.price}
            status={excursion.status}
        >
            <div className="uppercase">
                {excursion.portName}
            </div>
            <div>
                <Trans id="on_day">On day</Trans> {getDayNr(excursion.date, cruiseStartDate)} ({formatCartElementDate(excursion.date)})
            </div>
            <ul className="list-reset mt-4 md:grow">
                {excursion.passengers.map((passenger, index) =>
                    <li key={index}>{`${passenger.firstName} ${passenger.lastName}`}</li>)}
            </ul>
        </CartElementCheckout>
    )
}

export default CartExcursionEntryCheckout;